import { Pipe, PipeTransform } from '@angular/core';
import { Lookups } from '@ag-common-lib/public-api';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LookupsManagerService } from '../../public-api';

@Pipe({ name: 'lookupDescription' })
export class LookupDescriptionPipe implements PipeTransform {
  constructor(private lookupsManagerService: LookupsManagerService) {}

  transform(lookupId: string, lookup: Lookups): Observable<string> {
    if (!lookupId) {
      return from('');
    }
    return this.lookupsManagerService.getLookup(lookup, lookupId).pipe(
      map(item => {
        if (item?.exists()) {
          const data = item.data();
          return data?.description;
        }
        return '';
      }),
      // Prevent Firebase "missing/insufficient permissions" errors from bubbling to the UI.
      catchError(error => {
        console.warn(
          `Failed to resolve lookup description for id "${lookupId}" and lookup "${lookup}":`,
          error,
        );
        // As a safe fallback, show the raw id instead of breaking change logs / grids.
        return of(lookupId);
      }),
    );
  }
}
